import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OdataMeasurementToolsInstanceToken } from '../../interfaces/odata-measurement-tools.interface';
import { OdataMeasurementToolsService } from '../../services/measurement-tools/odata-measurement-tools.service';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { MeasurementToolsEffects } from './effects/measurement-tools.effects';
import { measurementToolsReducer } from './reducers/measurement-tools.reducer';
import { selectMeasurementTools } from './selectors/measurement-tools.selector';
import { MEASUREMENT_TOOLS_FEATURE_KEY } from './measurement-tools-collection.state';

/**
 * Registers the measurement-tools feature slice. `MeasurementToolsNgrxService.init()` loads
 * the data from the backend and dispatches `measurementToolsLoaded`; `MeasurementToolsEffects`
 * then mirrors the slice to the generic persistence layer so tools are available offline.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(MEASUREMENT_TOOLS_FEATURE_KEY, measurementToolsReducer),
        EffectsModule.forFeature([MeasurementToolsEffects]),
    ],
    providers: [
        {
            provide: OdataMeasurementToolsInstanceToken,
            useExisting: OdataMeasurementToolsService,
        },
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: MEASUREMENT_TOOLS_FEATURE_KEY,
                persistSelector: selectMeasurementTools,
            },
        },
    ],
})
export class MeasurementToolsStoreModule {}
